module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title1":"Активация аккаунта","title2":"Импорт вакансий","description1":"Чтобы начать получать видеоотклики от кандидатов, вам необходимо создать аккаунт в сервисе Huntica.","description2":"Вакансии с сайта Rabota.ru, для которых вы бы хотели настроить получение видеооткликов.","next":"Далее"}}')
  delete Component.options._Ctor
}
